<template>
  <section class="main-content">
    <MainBanner banner="Wir.Historie" />
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite - ito consult GmbH",
        "item": "https://ito-consult.de"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Über uns",
        "item": "https://ito-consult.de/wir"
      },{
        "@type": "ListItem",
        "position": 3,
        "name": "Historie",
        "item": "https://ito-consult.de/wir/historie"
      }]
    }
  </script>
    <section class="block-content py-5 mb-5 bg-grey">
        <div class="container my-md-5 py-md-5">
            <div class="content-midwide text-center" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
                <article v-html="historie_content"></article>
            </div>
        </div>
    </section>
    <section class="block-content mb-5">
        <div class="container my-md-5 py-md-5">
            <div id="timeline">
                <div v-for="(date,index) in history" :key="date.id" class="row history-item my-md-5 py-md-5 align-items-center" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
                    <div class="col-12 mb-3 mb-md-0 col-md-5" :class="{'order-md-2 offset-md-2' : index%2==0 }">
                        <div v-if="date.image" class="img-container history-image">
                            <img class="img-fluid" :src="generateThumbnail(date.image.data.asset_url,600,800,60,'contain')"  :title="date.date + ' - ' +date.title"/>
                        </div>
                    </div>
                    <div class="col-12 mb-3 mb-md-0 col-md-5 text" :class="{'text-md-end' : (index%2==0) , 'offset-md-2' : index%2}">
                        <h2>{{date.date}}</h2>
                        <h4>{{date.title}}</h4>
                        <article class="d-content" v-html="date.description"></article>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </section>
</template>

<script>

import axios from 'axios'
import store from '@/store'
const MainBanner = () => import('@/components/Content/MainBanner.vue')

export default {
  name: 'History',
  data: function () {
    return {
      history: {}
    }
  },
  metaInfo () {
    return {
      title: this.$parent.getMetaTitle('Wir.Historie'),
      meta: [
        { name: 'description', content: this.$parent.getDescription('Wir.Historie') },
        { property: 'og:title', content: this.$parent.getOGTitle('Wir.Historie') },
        { property: 'og:description', content: this.$parent.getOGDescription('Wir.Historie') }
      ]
    }
  },
  computed: {
    historie_content () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Historie-Einleitung') > -1
        })
        return txt.length ? txt[0].content : ''
      } else {
        return ''
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getHistoryData()
    })
  },
  components: {
    MainBanner
  },
  mounted () {
    store.commit('loadingStatus', false)
  },
  methods: {
    getHistoryData () {
      axios.get('/history?fields=*.*&sort=date')
        .then(response => (this.history = response.data.data))
    },
    generateThumbnail (asset, w, h, q, f) {
      return 'https://cdn.ito-consult.de' + asset + '?w=' + w + '&h=' + h + '&q=' + q + '&f=' + f
    }
  }

}
</script>
<style>
  #timeline .d-content ul {list-style: none; margin: 0; padding: 0;}
  #timeline .d-content ul li {margin: 0; padding: 0;}

  .history-item .text ul li {
    padding: 0 0 0 2rem !important;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="30px" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16"><path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/></svg>') top left no-repeat;
  }
  .history-item img {filter: grayscale(1) contrast(1.05); transition: all 1s;}
  .history-item:hover img{ filter: grayscale(0) contrast(1);}
  @media(min-width: 768px) {
    .history-item  .text ul li {
      margin: 0 0 0 -2rem !important; padding: 0 0 0 2rem !important;
    }
    .history-item  .text.text-md-end ul li {
      margin: 0 -2rem 0 0 !important; padding: 0 2rem 0 0 !important;
      background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="30px" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16"><path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/></svg>') top right no-repeat;
    }
  }
</style>
<style scoped>
  @media(min-width: 768px){
    #timeline {
            position: relative;

        }
        #timeline::before {
            content: "";
            width: 1px;
            height: 100%;
            position: absolute;
            top: 0;
            left: calc(50% - .5px);
            background: #ddd;
            display: block;
            z-index: -1;
        }

        #timeline .history-item .text {position: relative;}
        #timeline .history-item .text::after {
            content: "";
            width: 3rem;
            height: 3rem;
            position: absolute;
            top: 0; left: -5.2rem;
            background: url(~@/assets/gfx/dots.svg);
            background-size: 3rem 3rem;
            display: block;
            background-repeat: no-repeat;
            z-index: 3;
        }
        #timeline .history-item .text.text-md-end::after {
            top: 0; right: -5.2rem; left: auto;
        }
    }
    @media(min-width:992px){

        #timeline .history-item .text::after {left: -6.495rem}
        #timeline .history-item .text.text-md-end::after {right: -6.495rem}
    }
    @media(min-width:1200px){
        #timeline .history-item .text::after {left: -7.45rem}
        #timeline .history-item .text.text-md-end::after {right: -7.45rem}
    }
    @media(min-width:1400px){

        #timeline .history-item .text::after {left: -8.4rem}
        #timeline .history-item .text.text-md-end::after {right: -8.4rem}
    }

    .history-image {background: #eeeeee;}
</style>
